import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

@Component('NewsTeaser')
export class NewsTeaser extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async start() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
}
